module.exports = __webpack_public_path__ + "static/media/vlic-logo.7bc478ce.svg";